export default __webpack_public_path__ + "static/media/K5.fba7c632.png";